import { supabase } from "@/integrations/supabase/client";
import { useMutation } from "@tanstack/react-query";

interface UseReviewNotesManagerProps {
  reviewId: string;
}

export const useReviewNotesManager = ({ reviewId }: UseReviewNotesManagerProps) => {
  // Mutation to save notes
  const saveNotesMutation = useMutation({
    mutationFn: async (notes: string) => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (!user) throw new Error("User not authenticated");

      // Verify the inbound classification result exists
      const { data: review, error: reviewError } = await supabase
        .from("encounter_human_review")
        .select("id")
        .eq("id", reviewId)
        .maybeSingle();

      if (reviewError) {
        throw new Error(`Failed to verify classification result: ${reviewError.message}`);
      }

      if (!review) {
        throw new Error("Review not found");
      }

      // Update notes
      const { error } = await supabase
        .from("encounter_human_review")
        .update({
          notes: notes,
          updated_at: new Date().toISOString(),
        })
        .eq("id", reviewId);

      if (error) {
        throw error;
      }
    },
  });

  return saveNotesMutation;
};
